export default __webpack_public_path__ + "static/media/overreach4.abaa578d.png";